import { useMemo } from 'react'
import { EnumDropdownItemVariant, type IDropdownItem } from 'shared/ui/Dropdown'
import { FilterDropdown } from 'shared/ui/Table/ui/FilterDropdown/FilterDropdown'
import { type ITableProps } from '../Table'
import { type IOrderedGroups } from '../types'

type ISimpleFilterDropdownProps<TRow> = {
  columns: ITableProps<TRow>['columns']
  visibleColumnsIds?: ITableProps<TRow>['visibleColumnsIds']
  setVisibleColumnsIds: ITableProps<TRow>['setVisibleColumnsIds']
  noSearch?: boolean
}

export const SimpleFilterDropdown = <TRow,>({
  columns,
  visibleColumnsIds,
  setVisibleColumnsIds,
  noSearch,
}: ISimpleFilterDropdownProps<TRow>) => {
  const filterDropdownGroups: IOrderedGroups[] = useMemo(() => {
    return [
      {
        label: '',
        items: columns
          .reduce<IDropdownItem[]>((state, current) => {
            if (!current.isHideForManage) {
              state.push({
                id: current.field,
                label: current.fullName || current.name || '',
                variant: EnumDropdownItemVariant.Checkbox,
                activeValue: Boolean(visibleColumnsIds?.includes(current.field)),
                isCardClick: true,
                disabled: current.isDisabledChangeVisible,
              })
            }

            return state
          }, [])
          .filter(Boolean),
      },
    ]
  }, [columns, visibleColumnsIds])

  const onChangeItem = (item: IDropdownItem) => {
    if (visibleColumnsIds?.includes(item.id as string)) {
      setVisibleColumnsIds && setVisibleColumnsIds(visibleColumnsIds.filter((id) => id !== item.id))
    } else if (visibleColumnsIds) {
      setVisibleColumnsIds && setVisibleColumnsIds([...visibleColumnsIds, item.id as string])
    }
  }
  return (
    <FilterDropdown
      filterDropdownGroups={filterDropdownGroups}
      changeActiveFields={onChangeItem}
      autoHeightMax={350}
      iconButtonProps={{
        transparentInactive: true,
        ariaLabel: 'SimpleFilterDropdown_manageColumns',
      }}
      placement='bottom-end'
      tooltipLabel='Manage columns'
      noSearch={noSearch}
      ariaLabel='Manage columns'
    />
  )
}
